// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3V06m","question":"Question_question__WygPA","description":"Question_description__3QpP_"};